import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import enquiry from "../method/enquiry";
import crmEnquiry from "../method/lead";
import checkAnim from "../asset/checkAnim.gif";
import tickIcon from "../asset/check.JPG";
import "../style/pup1.css";
import { getImage } from "../module/api_init";
import "../style/promotion.css";
import Qr_code from "../asset/QR_Code.png";
import { appStore, playStore } from "../module/logo";

function EnquiryPopup({ props }) {
  const [booked, setbooked] = useState(0);
  const types = [
    "Get On-road Price", // 0
    "Get New Offer", // 1
    "Get EMI Offer", // 2
    "BOOK A TEST RIDE", // 3
    "ONLINE SERVICE BOOKING", // 4
    "Enquiry", // 5
    "Get Best Offers", // 6
    "Price in my city", // 7
    "Register Service", // 8
    "Insurance Enquiry", // 9
    "Find Career at Kalyani Motors", // 10
    "Book Kalyani Driving School", // 11
    "Enquiry New Dzire", // 12
    "Enquiry E Vitara", // 13
  ];
  const { enquiryPopup } = props.state;

  const locationBasedVariant =
    window.location.pathname.includes("allcars") ||
    window.location.pathname.includes("car");
  if (enquiryPopup === null) return null;

  const specialCases = [2, 5, 8, 9, 10, 11, 12, 13];
  const isSpecialCase = specialCases.includes(Number(enquiryPopup?.type));

  const popupModelName = isSpecialCase
    ? enquiryPopup.type === 5
      ? enquiryPopup.location
      : enquiryPopup.car
    : enquiryPopup.item.name;

  const popupVariant = isSpecialCase
    ? enquiryPopup.car
    : locationBasedVariant
    ? enquiryPopup.item.name
    : enquiryPopup.item.varient.var_title || enquiryPopup.car;

  const popupChannel =
    enquiryPopup.type === 8
      ? "Service"
      : isSpecialCase
      ? "Arena"
      : enquiryPopup.item.category_id === 1
      ? "Nexa"
      : "Arena";

  const popupPurpose = isSpecialCase
    ? enquiryPopup.type === 5
      ? "Branch Contact Enquiry"
      : enquiryPopup.car
    : types[enquiryPopup.type];
  const popupVehicle = isSpecialCase
    ? enquiryPopup.type === 5
      ? "Branch Contact Enquiry"
      : enquiryPopup.car
    : enquiryPopup.item.body;

  return (
    <div className="pup1_a_a">
      <div className="pup1_a_b">
        {booked === 0 ? (
          <div className="pup1_a_c">{types[enquiryPopup.type]}</div>
        ) : (
          <></>
        )}
        {booked !== 0 ? (
          booked === 1 ? (
            <img
              alt="Kalyani Motors Leading Maruti Suzuki Dealership"
              className="pup1_a_d"
              src={checkAnim}
              style={{ display: "none" }}
            />
          ) : (
            <img
              alt="Kalyani Motors Leading Maruti Suzuki Dealership"
              className="pup1_a_d"
              src={tickIcon}
              style={{ display: "none" }}
            />
          )
        ) : (
          <form
            id="booking_form"
            onSubmit={async (e) => {
              e.preventDefault();
              if (e.target.phone.value.length !== 10) {
                alert("Not a valid phone number");
                return;
              }
              setbooked(1);
              const body = {
                name: e.target.name.value,
                phone: e.target.phone.value,
                email: e.target.email ? e.target.email.value : "",
                city: e.target.city ? e.target.city.value : "",
                location: localStorage.getItem("location"),
                vehicle: e.target.carName.value,
                purpose: types[enquiryPopup.type],
              };
              const crmEnquiryBody = {
                emailAddress: e.target.email ? e.target.email.value : "",
                crmSource: "KM Website",
                creAgent: "",
                "Phone Number": e.target.phone.value,
                Name: e.target.name.value,
                "Email Address": e.target.email ? e.target.email.value : "",
                uniquePhone: true,
                skill: "",
                process: "KAM",
                campaignId: "688c5d85d5e83faa10312c15",
                campaignName: "Kalyani Motors",
                agentId: "",
                requestFrom: "website",
                modelName: popupModelName,
                purpose: popupPurpose,
                location: localStorage.getItem("location"),
                // variant:
                //   popupVariant === undefined
                //     ? "Branch Contact Enquiry"
                //     : popupVariant,
                // channel: popupChannel,
                // crmSource: "Google Ads",
                // leadType: "Website",
                // isPrimary: "Yes",
                // leadDate: new Date().toLocaleDateString(),
                // transUniqueId: Math.floor(Math.random() * 10000),
                // vehicle: popupVehicle,
              };
              // enquiry(body),
              await Promise.all([enquiry(body), crmEnquiry(crmEnquiryBody)]);
              // setTimeout(() => {
              // 	setbooked(0);
              // 	props.setState({ enquiryPopup: null });
              // }, 3000);
            }}
          >
            <input
              placeholder="Name"
              className="pup1_a_e"
              type="text"
              required
              id="name"
            />
            {(enquiryPopup.type === 12 || enquiryPopup.type === 13) && (
              <>
                <input
                  placeholder="Email"
                  className="pup1_a_e"
                  type="email"
                  id="email"
                  required
                />
                <input
                  placeholder="City"
                  className="pup1_a_e"
                  type="text"
                  id="city"
                  required
                />
              </>
            )}
            <input
              placeholder="Phone Number"
              className="pup1_a_e"
              type="text"
              required
              id="phone"
            />
            <input
              type="text"
              className="pup1_a_e"
              value={types[enquiryPopup.type]}
              id="carName"
              disabled
            />
            <div className="pup_checkbox_container">
              <input
                type="checkbox"
                required
                id="checkbox"
                className="pup_checkbox"
              />
              <label htmlFor="checkbox" className="pup_checkbox_label">
                <span style={{ fontWeight: "600" }}>Disclaimer:</span> I
                authorize Kalyani Motors to send notifications via SMS, Kalyani
                Super App, WhatsApp, Email and RCS.
              </label>
            </div>
            <button type="submit" className="pup1_a_f">
              {types[enquiryPopup.type]}
            </button>
          </form>
        )}
        {booked !== 0 ? (
          <>
            <div className="promotion_container">
              <div className="promotion_content">
                <p className="promotion_content_title">
                  Your Enquiry Was Sent Successfully!
                </p>
                <p className="promotion_content_desc">
                  Thank you for contacting us. we have received your enquiry and
                  will be in touch shortly
                </p>
                <hr className="line" />
                <p className="promotion_content_desc2">
                  Stay connected with Super App
                </p>
                <p className="promotion_content_desc">
                  Track your requests, get instant updates, and explore
                  exclusive features right from your phone.
                </p>
              </div>
              <div className="promotion_download">
                <div className="promotion_download_content">
                  <div>
                    <img
                      src={Qr_code}
                      alt="QR code for app download"
                      className="promotion_qr"
                    />
                  </div>
                  <div className="promotion_buttons">
                    <img
                      width="150"
                      alt="Kalyanimotors Leading Maruti Suzuki Dealership"
                      src={playStore}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        (window.location =
                          "https://play.google.com/store/search?q=kalyani+motors+super+app")
                      }
                    />
                    <img
                      width="150"
                      alt="Kalyanimotors Leading Maruti Suzuki Dealership"
                      src={appStore}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        (window.location =
                          "https://apps.apple.com/in/app/kalyani-motors-app/id6479185557")
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <div
          onClick={() => props.setState({ enquiryPopup: null }, setbooked(0))}
          className="pup1_a_h"
        >
          Close
        </div>
      </div>
    </div>
  );
}

function CarPopup({ props }) {
  const count = props.state.selectedImage;
  const { car, versionCount, colorCount } = props.state;
  if (count === null) return null;
  return (
    <div
      style={{
        width: "100vw",
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          maxWidth: 800,
          width: "100%",

          position: "fixed",
          boxShadow: "1px 1px 4px gray",
          background: "white",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: 22,
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              cursor: "pointer",
              padding: "10px 20px",
              paddingBottom: 2,
            }}
            onClick={() => props.setState({ selectedImage: null })}
          >
            X
          </div>
        </div>
        <Carousel useKeyboardArrows>
          {car.varients[versionCount].products[colorCount].images.map((img) => (
            <img
              alt="Kalyani Motors Leading Maruti Suzuki Dealership"
              src={getImage(img.images)}
              style={{
                maxWidth: 700,
                width: "100%",
                objectFit: "cover",
                border: "1px solid #ccc",
                borderRadius: 8,
              }}
            />
          ))}
        </Carousel>
      </div>
    </div>
  );
}

export { EnquiryPopup, CarPopup };
